import React from 'react'
import './SideBar.css'

export const SideBar = () => {
  return (
    <div className='side-bar'>
        Account:
    <ul>
        <li className='item'>Sign In to Account</li>
        <li className='item'>Return and Orders</li>
    </ul>
    </div>
  )
}
